import { useMemo, useState } from "react";

import {
  Box,
  Grid,
  Input,
  Button,
  Spacer,
  PageTitle,
  Text,
  EmptyState,
  Modal,
  ModalBody,
  Select,
} from "@flexisaf/flexibull2";
import useSubjectsGet from "../../hooks/subjects/useSubjectsGet";

import Theme from "../../theme";
import SubjectCard from "./support/subjectCard";
import SectionLoader from "../../components/custom/sectionLoader";
import SubjectEditor from "./support/subjectEditor";
import { useNavigate } from "react-router-dom";
import { DefaultCurriculum } from "../../utils/constants";

const Subjects = () => {
  const navigate = useNavigate();
  const [modal, setModal] = useState({
    show: false,
    data: null,
  });

  const { loadingSubjects, subjects, curriculumType, setCurriculumType } =
    useSubjectsGet();
  const [searchText, setSearchText] = useState("");

  let filteredSubjects = useMemo(() => {
    return subjects.filter((subject) => {
      return subject.name.toLowerCase().includes(searchText.toLowerCase());
    });
  }, [subjects, searchText]);

  if (loadingSubjects)
    return <SectionLoader height="70vh" color={Theme.PrimaryColor} />;

  return (
    <Box>
      <PageTitle>
        <i className="saf-category-2" />
        <Text bold title="CBT" size={Theme.H3} style={{ padding: "0 10px" }}>
          Subjects
        </Text>
      </PageTitle>
      {subjects.length === 0 ? (
        <Box align="center">
          <EmptyState
            type="documents"
            title="You have not created any subject"
            action={
              <Button onClick={() => setModal({ show: true, data: null })}>
                Create Subject
              </Button>
            }
          />
        </Box>
      ) : (
        <>
          {" "}
          <Grid
            default="minmax(auto, 400px)  minmax(auto, 300px) auto max-content max-content"
            sm="1fr"
          >
            <Input
              name="search"
              placeholder="Search subjects"
              iconLeft="saf-search-normal"
              onChange={(e) => setSearchText(e.target.value)}
              value={searchText}
            />
            <Box>
              <Select
                block
                placeholder="Select curriculum type"
                options={DefaultCurriculum?.map((item) => {
                  return {
                    label: item.label,
                    value: item.value,
                  };
                })}
                value={curriculumType}
                onChange={(value) => setCurriculumType(value)}
              />
            </Box>
            <Box />
            <Box />

            <>
              <Button onClick={() => setModal({ show: true, data: null })}>
                Create Subject
              </Button>
            </>
          </Grid>
          <Spacer space="40px" />
          {filteredSubjects.length > 0 ? (
            <Grid default="1fr 1fr 1fr 1fr" gap="20px">
              {filteredSubjects.map((subject) => {
                return (
                  <SubjectCard
                    key={subject.id}
                    name={subject.name}
                    desc={subject?.description}
                    id={subject.id}
                    curriculum={subject?.curriculum}
                    handleEdit={(id, name, curriculum, desc) =>
                      setModal({
                        show: true,
                        data: {
                          id,
                          name,
                          desc,
                          curriculum,
                        },
                      })
                    }
                    handleTopicView={(name) => navigate(`/topics/${name}`)}
                  />
                );
              })}
            </Grid>
          ) : (
            <Box>
              <EmptyState
                type="documents"
                title="Subject not found."
                info="Please create subject to proceed"
              />
            </Box>
          )}
        </>
      )}
      <Modal open={modal.show} center={false}>
        <ModalBody width="600px">
          <SubjectEditor
            closeModal={() => setModal({ show: false, data: null })}
            data={modal.data}
          />
        </ModalBody>
      </Modal>
    </Box>
  );
};

export default Subjects;
